import React from 'react'
import { Drawer, List, ListItem, ListItemText } from '@material-ui/core'
import { Link, useLocation } from 'react-router-dom'
import { useSidebarStyles } from './Sidebar.styles'

const routes = [
  {
    path: '/admin/prompts/system',
    label: 'System Prompts',
  },
  {
    path: '/admin/prompts/project',
    label: 'Project Prompts',
  },
  {
    path: '/admin/llm-settings',
    label: 'LLM Settings',
  },
]

function Sidebar() {
  const classes = useSidebarStyles()
  const location = useLocation()

  const isActive = path => location.pathname === path

  return (
    <Drawer
      variant="persistent"
      open
      anchor="left"
      className={classes.drawer}
      classes={{ paper: classes.drawerPaper }}
    >
      <List>
        {routes.map(route => (
          <ListItem
            key={route.path}
            button
            component={Link}
            to={route.path}
            selected={isActive(route.path)}
          >
            <ListItemText primary={route.label} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  )
}

export default Sidebar
